<script lang='ts'>
  import * as _ from 'lodash';
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import type { DistributorSellSheet } from '@shared/types/SellSheet';
  import Autocomplete from "@shared/svelte/Components/Autocomplete.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Modal from '@shared/svelte/Components/Modal.svelte'
  import Flash from "@shared/services/flashv2.js";

  export let sellSheet:DistributorSellSheet;
  export let onCloseModal;
  export let showCopyModal:boolean;

  let status = {loading: false, errors: null};
  let cloneToList = [];
  let shareWith = 'myself';
  let distributor_id = sellSheet.distributor_id;
  let newName = null;
  let role:string = '';
  if (window['$rootScope'].user?.manufacturers) {
    role = window['$rootScope'].user.manufacturers[0].role;
  } else {
    role = window['$rootScope'].user?.distributors[0].role;
  }

  const doCopying = async function(sellSheet:DistributorSellSheet) {
    let copyToUsers = [];
    let cloneToAll = false;
    let myself = false;

    if (shareWith == 'specific'){
      copyToUsers = _.map(cloneToList, function(x) { return {id: x.user_ids[0]} });
    } else if (shareWith == 'all'){
      copyToUsers = [];
      cloneToAll = true;
    } else {
      copyToUsers = [window['$rootScope'].user];
      myself = true;
    }

    if (status.loading) { return; }
    status.loading = true;

    try {
      await HttpPromise({
        method: 'POST',
        url: `/api/distributor/sell_sheets/${sellSheet.id}/clone`,
        data: {
          name: newName,
          clone_to_users: copyToUsers,
          clone_to_all: cloneToAll
        }
      })
      onCloseModal();
      if (myself) {
        Flash.queue({message: 'Your product sheet has been copied successfully!', type: 'success'});
        window['stateService'].go('layout.product_sheets', {order: "created_at", direction: "DESC"});
      } else {
        Flash.now({message: 'Your product sheet has been copied successfully!', type: 'success'});
      }
    } catch (error) {
      status.errors = {messages: error};
      status.loading = false;
    }
  };
</script>

<Modal bind:show={showCopyModal} closeOnBackgroundClick={true} fizzModal={true} size={'medium'} fixedHeaderAndFooter={true}>
  <div class="background-white distributors__product_success_modal">
    <div class="modal__header padding--small">
      <span class="s3 strong">Copy Product Sheet</span>
      <span class="float-right"><Icon type="X" height="16" width="16" extraClassNames={"cursor-pointer opacity-60 display-inline-block margin-top--smallest"}
        onPress={onCloseModal} /></span>
    </div>

    <div class="padding--medium">
      <div class="grid-row">
        <div class="padding-left--smaller padding-right--smaller">
          <div class="display-block full-width s5 margin-bottom--smallest">
            <span class="strong">Name</span>
          </div>
        </div>
      </div>

      <div class ="grid-row">
        <input type="text" class="fizz-input-text fizz-full-width fizz-stack-8" bind:value={newName}
        placeholder={sellSheet.name} />
      </div>

      <div class="display-block full-width s5 margin-bottom--smallest">
        <span class="strong">Make a copy for:</span>
      </div>

      <div class="padding-bottom--smaller">
        <div class="grid-row"></div>
        <label class='margin--smallest cursor-pointer' for='myself'>
          <input type='radio' bind:group={shareWith} name='shareWith' id='myself' value='myself' />
          Myself
        </label>

        <div class="grid-row"></div>
        <label class='margin--smallest cursor-pointer' for='specific'>
          <input type='radio' bind:group={shareWith} name='shareWith' id='specific' value='specific' />
          Specific Employees
        </label>

        {#if role == 'supplier_admin' || role == 'distributor_admin'}
          <div class="grid-row"></div>
          <label class='margin--smallest cursor-pointer' for='all'>
            <input type='radio' bind:group={shareWith} name='shareWith' id='all' value='all' />
            All Employees
          </label>
        {/if}
      </div>

      <div class='padding-bottom--small add_product_modal_autocomplete'>
        {#if shareWith == 'specific'}
          <Autocomplete
            objectType="sales_rep"
            searchUrlInput="/api/distributor/sales_reps"
            addFromAutocompleteOnly={true} listMode={true} field={'display_name'}
            apiParams={{"require_users": true, "distributor_id": distributor_id}}
            bind:value={cloneToList} placeholder="Search for Sales Reps"
          />
        {/if}
      </div>
    </div>

    <footer class="modal__footer align-right padding--small">
      <button class="button button--secondary float-left" on:click={onCloseModal}>
        Cancel
      </button>
      <button class="button button--primary copy-sheet-button"
        disabled={status.loading}
        on:click={() => doCopying(sellSheet)}>
        Copy Product Sheet
      </button>
    </footer>
  </div>
</Modal>
